/**
 * 決定論的な乱数。Math.random は使わない。
 * 理由：CLAUDE.md §4.5（DT固定＝再現性）と §6（不具合の再現用セーブ）。
 * 状態が数値ひとつなので、そのまま GameState に載せてシリアライズできる。
 */
export interface RngState {
  s: number;
}

export function createRng(seed: number): RngState {
  return { s: seed >>> 0 };
}

/** mulberry32 */
export function rngFloat(rng: RngState): number {
  rng.s = (rng.s + 0x6d2b79f5) >>> 0;
  let t = rng.s;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

/** 0 <= n < max の整数 */
export function rngInt(rng: RngState, max: number): number {
  return Math.floor(rngFloat(rng) * max);
}

export function rngRange(rng: RngState, min: number, max: number): number {
  return min + rngFloat(rng) * (max - min);
}

export function rngPick<T>(rng: RngState, arr: readonly T[]): T | null {
  if (arr.length === 0) return null;
  return arr[rngInt(rng, arr.length)];
}
